import React from "react";
import { View, Text, TextInput, Button, Icon } from "ui";
import { memoMutations } from "api";
import { Memo } from "types";

interface P {
  memo: Memo;
}
interface S {
  title?: string;
  editPressed?: boolean;
  input?: string;
}

export default class EditTitle extends React.Component<P, S> {
  public state: S = {
    editPressed: false,
    title: this.props.memo.name,
    input: ""
  };

  public handleEdit = () => {
    this.setState({ editPressed: true, input: this.state.title });
  }

  public handleConfirm = () => {
    this.setState({ editPressed: false, title: this.state.input });
  }

  public handleCancel = () => {
    this.setState({ editPressed: false });
  }

  public render = () => {
    const { memo } = this.props;
    const { editPressed, title, input } = this.state;
    return (
      <View flexDirection="row" alignItems="center" justifyContent="center">
        {!editPressed && (
          <View flexDirection="row" alignItems="center" justifyContent="center">
            <Text mr={5} fontSize={5}>
              {title}
            </Text>
            <View style={{ cursor: "pointer" }} onClick={this.handleEdit}>
              <Icon name="pencil" color="#f16541" size={2} />
            </View>
          </View>
        )}

        {editPressed && (
          <View>
            <memoMutations.UpdateMemo>
              {updateMemo => (
                <form
                  onSubmit={async e => {
                    e.preventDefault();

                    try {
                      await updateMemo({
                        variables: {
                          id: memo.id,
                          categoryId: memo.category_id,
                          name: input
                        }
                      });
                      this.handleConfirm();
                    } catch (ex) {}
                  }}
                >
                  <View
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <TextInput
                      mr={4}
                      value={input}
                      height="3rem"
                      onChange={e => this.setState({ input: e.target.value })}
                    />
                    <Button
                      p={0}
                      bg="transparent"
                      as="button"
                      type="submit"
                      border="none"
                    >
                      <Icon name="check-circle" color="#f16541" size={2} />
                    </Button>
                    <View mr={3} />
                    <Button
                      p={0}
                      bg="transparent"
                      as="button"
                      type="submit"
                      border="none"
                      style={{ cursor: "pointer" }}
                      onClick={this.handleCancel}
                    >
                      <Icon name="close-circle" color="#f16541" size={2} />
                    </Button>
                  </View>
                </form>
              )}
            </memoMutations.UpdateMemo>
          </View>
        )}
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditTitle.tsx